<section id="section-responsive-table" class="container m-t-40">
  <div class="simple-card">
    <p class="h2 p-tb-12 border-bottom m-b-0">Tables Responsive (Searchable)</p>

    <table-pro [configs]="tableConfig">
      <table class="table-responsive table-md">
        <thead>
          <tr>
            <th>Name</th>
            <th>Age</th>
            <th>Address</th>
            <th>Phone</th>
            <th>Document</th>
            <th>Status</th>
            <th>Date</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          @for (user of users; track user) {
            <tr>
              <td [attr.data-value]="user.name">
                <span class="responsive-title"> Name: </span>
                {{ user.name }}
              </td>
              <td [attr.data-value]="user.age">
                <span class="responsive-title"> Age: </span>
                {{ user.age }}
              </td>
              <td [attr.data-value]="user.address">
                <span class="responsive-title"> Address: </span>
                {{ user.address }}
              </td>
              <td [attr.data-value]="user.phone">
                <span class="responsive-title"> Phone: </span>
                {{ user.phone }}
              </td>
              <td [attr.data-value]="user.document">
                <span class="responsive-title"> Document: </span>
                {{ user.document }}
              </td>
              <td [attr.data-value]="user.isOk">
                <span class="responsive-title"> Status: </span>
                {{ user.isOk }}
              </td>
              <td [attr.data-value]="user.date">
                <span class="responsive-title"> Status: </span>
                {{ user.date | date: 'dd/MM/yyyy' }}
              </td>
              <td [attr.data-value]="user.totalValue.value">
                <span class="responsive-title"> Total: </span>
                {{ user.totalValue.formattedValue }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </table-pro>
  </div>
</section>
